export default __webpack_public_path__ + "static/media/training-paperwork.e23c2eae.png";